export default function initFlashMessages() {
  const flashMessages = document.querySelectorAll(".flash")

  if(flashMessages.length > 0) {
    Array.from(flashMessages).forEach((flash) => {
      flash.addEventListener("click", (event) => {
        flash.classList.add('hidden')
      })

      const trackingEvent = flash.querySelector("[data-track-event]")
      if(trackingEvent) {
        const eventName = trackingEvent.dataset.trackEvent
        const eventKey = `gtm_event_${eventName}`

        if (!sessionStorage.getItem(eventKey)) {
          dataLayer.push({
            'event': eventName
          });
          sessionStorage.setItem(eventKey, '1')
        }
      }
    })
  }
}
